import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { DutyCode } from 'generated';
import { useSelector } from 'hooks';
import { sortBy, uniqBy } from 'lodash';
import styled from 'styled-components';

import { OpenDuty, PlannedDuty } from './types';

import { formatISOString } from 'utils/date';

import { FontAwesomeSvgIcon } from 'components/shared';

const DutyCodeCellStyles = styled.div`
  .function span {
    font-size: 0;
  }

  .function-color {
    margin-right: 4px;
    width: 6px;
    height: 6px;
  }

  .dutyCode {
    display: inline;
    margin-bottom: 3px;
    font-size: 14px;

    + .dutyCode {
      &::before {
        content: '/';
        display: inline-block;
        margin: 0 5px;
      }
    }

    span {
      font-family: 'signikabold';
      border-bottom: 3px solid transparent;
    }
  }
`;

type Props = {
  duties: (PlannedDuty | OpenDuty)[];
  isGroupedByFunction: boolean;
  isGroupedByPlanunit: boolean;
};

export default function DutyCodeCell({
  duties,
  isGroupedByFunction,
  isGroupedByPlanunit
}: Props) {
  const { dutyCode, costCenter, function: func, periods } = duties[0];
  const preferences = useSelector((state) => state.preferences);
  const { name: functionName, colorCode: functionColor } = func || {};
  const uniqDutyCodes = sortBy(
    uniqBy(
      duties.filter(({ dutyCode }) => dutyCode),
      'dutyCode.code'
    ),
    'dutyCode.code'
  )
    .map(({ dutyCode }) => dutyCode as DutyCode)
    .slice(0, isGroupedByPlanunit ? 1 : undefined);
  return (
    <DutyCodeCellStyles>
      {dutyCode && (
        <>
          {uniqDutyCodes.map(({ code, dutyCode, colorCode, dutyCodeId }) => (
            <div className="dutyCode" key={dutyCodeId}>
              <span style={{ borderBottomColor: colorCode || '' }}>
                {code || dutyCode}
              </span>
            </div>
          ))}
          {dutyCode.description && (
            <div className="duty-description">{dutyCode.description}</div>
          )}
          {isGroupedByPlanunit && costCenter && (
            <div>
              <b>{costCenter.name}</b>
            </div>
          )}
          <div className="periods">
            {periods?.map(({ start, end, dutyHourType }) => (
              <div key={start + end} className="period">
                {formatISOString(start, 'p')} -&nbsp;
                {formatISOString(end, 'p')}
                {preferences.showDutyHourTypes && dutyHourType && (
                  <>
                    &nbsp;|&nbsp;
                    <span className="dht-code">{dutyHourType.code}</span>
                  </>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      {isGroupedByFunction && functionName && (
        <div className="function d-flex v-center">
          {functionColor && (
            <span style={{ color: functionColor }}>
              <FontAwesomeSvgIcon
                color="inherit"
                icon={faCircle}
                fontSize="small"
                className="function-color"
              />
            </span>
          )}
          <small>{functionName}</small>
        </div>
      )}
    </DutyCodeCellStyles>
  );
}
